// JAZ Sales - Phase 3 (calls, follow-ups, demos, trials) strings, merged into the Sales dictionary by salesTranslations.js.
// Arabic and English are equal partners: every key exists in both, and every placeholder ({n}, {stage}, ...) appears in
// both languages (scripts/check_i18n.py-style checks enforce it).
export const activitiesTranslations = {
  ar: {
    // ---- navigation and page titles
    nav_followups: 'المتابعات',
    nav_calls: 'المكالمات',
    nav_demos: 'العروض التجريبية',
    nav_trials: 'الفترات التجريبية',
    followups_title: 'المتابعات',
    calls_title: 'المكالمات',
    demos_title: 'العروض التجريبية',
    trials_title: 'الفترات التجريبية',
    trials_subtitle: 'تتبّع داخلي لفريق المبيعات فقط - لا يُنشئ اشتراكاً ولا يغيّر أي شيء في حسابات العملاء.',

    // ---- shared table / card labels
    act_col_lead: 'العميل المحتمل',
    act_col_assignee: 'المسؤول',
    act_col_status: 'الحالة',
    act_col_actions: 'إجراءات',
    act_col_due: 'الموعد',
    act_col_when: 'الوقت',
    act_col_employee: 'أجراها',
    act_col_result: 'النتيجة',
    act_col_duration: 'المدة',
    act_col_called_at: 'وقت المكالمة',
    act_col_started: 'البداية',
    act_col_expected_end: 'النهاية المتوقعة',
    act_col_ended: 'النهاية الفعلية',
    act_search_placeholder: 'اسم العميل المحتمل أو جهة الاتصال',
    act_no_notes: 'لا توجد ملاحظات',
    act_overdue: 'متأخرة',
    act_past_due: 'تجاوز الموعد',
    act_ending_soon: 'تنتهي قريباً',
    act_trial_overdue: 'تجاوزت نهايتها المتوقعة',
    act_needs_outcome: '{n} عرض بحاجة إلى تسجيل النتيجة',
    act_lead_archived: 'مؤرشف',
    act_error: 'تعذر تحميل القائمة',
    act_empty_filtered_hint: 'جرّب مسح عوامل التصفية.',
    act_you: 'أنت',
    act_note: 'ملاحظة',
    act_assignee: 'المسؤول',
    act_assignee_hint: 'يمكن اختيار موظف يستطيع العمل على هذا العميل المحتمل فقط.',
    act_assignee_none: 'لا يوجد من يمكن إسناد هذا إليه. عيّن العميل المحتمل لموظف مبيعات أولاً.',
    act_required: 'هذا الحقل مطلوب',
    act_scope_hint: 'تظهر هنا العناصر الخاصة بالعملاء المحتملين المتاحين لك فقط.',

    // ---- calls
    call_result_answered: 'تم الرد',
    call_result_no_answer: 'لم يتم الرد',
    call_result_busy: 'مشغول',
    call_result_wrong_number: 'رقم خاطئ',
    call_result_interested: 'مهتم',
    call_result_not_interested: 'غير مهتم',
    call_result_call_back: 'طلب معاودة الاتصال',
    calls_add: 'تسجيل مكالمة',
    calls_showing_recent: 'أحدث المكالمات أولاً',
    calls_empty: 'لا توجد مكالمات مسجلة بعد',
    calls_empty_hint: 'سجّل المكالمة من صفحة العميل المحتمل.',
    calls_empty_filtered: 'لا توجد مكالمات مطابقة',
    calls_filter_from: 'من تاريخ',
    calls_filter_to: 'إلى تاريخ',
    calls_filter_made_by: 'أجراها',
    calls_filter_mine: 'مكالماتي',
    call_dialog_create_title: 'تسجيل مكالمة',
    call_dialog_edit_title: 'تعديل المكالمة',
    call_dialog_hint: 'المكالمة سجلّ لما حدث فعلاً، ولا تغيّر مرحلة العميل المحتمل تلقائياً.',
    call_field_result: 'النتيجة',
    call_field_result_placeholder: 'اختر النتيجة',
    call_field_called_at: 'وقت المكالمة',
    call_field_duration: 'مدة المكالمة',
    call_field_minutes: 'دقائق',
    call_field_seconds: 'ثوانٍ',
    call_field_notes: 'ملاحظات المكالمة',
    toast_call_created: 'تم تسجيل المكالمة',
    toast_call_updated: 'تم تحديث المكالمة',

    // ---- follow-ups
    followup_status_pending: 'قيد الانتظار',
    followup_status_completed: 'مكتملة',
    followup_status_cancelled: 'ملغاة',
    followups_tab_mine: 'متابعاتي',
    followups_tab_upcoming: 'القادمة',
    followups_tab_overdue: 'المتأخرة',
    followups_tab_completed: 'المكتملة',
    followups_add: 'إضافة متابعة',
    followups_empty_mine: 'لا توجد متابعات معلّقة مسندة إليك',
    followups_empty_upcoming: 'لا توجد متابعات قادمة',
    followups_empty_overdue: 'لا توجد متابعات متأخرة',
    followups_empty_completed: 'لا توجد متابعات مكتملة بعد',
    followups_empty_hint: 'أضف المتابعة من صفحة العميل المحتمل.',
    followup_dialog_create_title: 'إضافة متابعة',
    followup_dialog_edit_title: 'تعديل المتابعة',
    followup_field_due: 'موعد المتابعة',
    followup_field_notes: 'ماذا يجب فعله؟',
    followup_action_complete: 'إنجاز',
    followup_action_cancel: 'إلغاء المتابعة',
    followup_complete_title: 'إنجاز المتابعة',
    followup_complete_hint: 'يمكنك إضافة ملاحظة عمّا تم. تُسجَّل في سجل العميل المحتمل.',
    followup_cancel_title: 'إلغاء المتابعة',
    followup_cancel_hint: 'لن تُحذف المتابعة، بل تُعلَّم ملغاة ويُسجَّل ذلك في سجل العميل المحتمل.',
    toast_followup_created: 'تمت إضافة المتابعة',
    toast_followup_updated: 'تم تحديث المتابعة',
    toast_followup_completed: 'تم إنجاز المتابعة',
    toast_followup_cancelled: 'تم إلغاء المتابعة',

    // ---- demos
    demo_status_scheduled: 'مجدول',
    demo_status_completed: 'تم',
    demo_status_cancelled: 'ملغى',
    demo_status_no_show: 'لم يحضر',
    demos_tab_upcoming: 'القادمة',
    demos_tab_completed: 'المكتملة',
    demos_tab_closed: 'الملغاة / لم يحضر',
    demos_add: 'جدولة عرض تجريبي',
    demos_empty_upcoming: 'لا توجد عروض تجريبية مجدولة',
    demos_empty_completed: 'لا توجد عروض تجريبية مكتملة بعد',
    demos_empty_closed: 'لا توجد عروض ملغاة أو تغيّب أصحابها',
    demos_empty_hint: 'جدوِل العرض من صفحة العميل المحتمل.',
    demo_dialog_create_title: 'جدولة عرض تجريبي',
    demo_dialog_edit_title: 'تعديل العرض التجريبي',
    demo_dialog_hint: 'تتبّع داخلي فقط، دون ربط بتقويم خارجي. جدولة العرض لا تغيّر مرحلة العميل المحتمل تلقائياً.',
    demo_field_when: 'موعد العرض',
    demo_field_notes: 'ملاحظات العرض',
    demo_action_reschedule: 'إعادة الجدولة',
    demo_action_complete: 'تم العرض',
    demo_action_cancel: 'إلغاء',
    demo_action_no_show: 'لم يحضر',
    demo_reschedule_title: 'إعادة جدولة العرض',
    demo_reschedule_hint: 'الموعد الجديد وسبب التغيير (اختياري) يُسجَّلان في سجل العميل المحتمل.',
    demo_complete_title: 'تسجيل إتمام العرض',
    demo_cancel_title: 'إلغاء العرض',
    demo_no_show_title: 'تسجيل عدم الحضور',
    demo_end_hint: 'يمكنك إضافة ملاحظة. تُسجَّل في سجل العميل المحتمل ولا يمكن التراجع عن الحالة.',
    toast_demo_scheduled: 'تمت جدولة العرض التجريبي',
    toast_demo_updated: 'تم تحديث العرض التجريبي',
    toast_demo_rescheduled: 'تمت إعادة جدولة العرض',
    toast_demo_completed: 'تم تسجيل إتمام العرض',
    toast_demo_cancelled: 'تم إلغاء العرض',
    toast_demo_no_show: 'تم تسجيل عدم الحضور',

    // ---- trials (Sales-side tracking)
    trial_status_active: 'نشطة',
    trial_status_completed: 'مكتملة',
    trial_status_cancelled: 'ملغاة',
    trials_tab_active: 'النشطة',
    trials_tab_ending: 'تنتهي قريباً',
    trials_tab_completed: 'المكتملة',
    trials_tab_cancelled: 'الملغاة',
    trials_add: 'بدء فترة تجريبية',
    trials_empty_active: 'لا توجد فترات تجريبية نشطة',
    trials_empty_ending: 'لا توجد فترات تجريبية تنتهي قريباً',
    trials_empty_completed: 'لا توجد فترات تجريبية مكتملة بعد',
    trials_empty_cancelled: 'لا توجد فترات تجريبية ملغاة',
    trials_empty_hint: 'ابدأ الفترة من صفحة العميل المحتمل.',
    trial_dialog_start_title: 'بدء فترة تجريبية',
    trial_dialog_edit_title: 'تعديل الفترة التجريبية',
    trial_dialog_hint: 'تتبّع داخلي لفريق المبيعات فقط: لا يُنشئ اشتراكاً ولا يغيّر شيئاً في حسابات العملاء. لكل عميل محتمل فترة تجريبية نشطة واحدة فقط.',
    trial_field_started: 'بداية الفترة',
    trial_field_expected_end: 'النهاية المتوقعة',
    trial_field_actual_end: 'النهاية الفعلية',
    trial_field_notes: 'ملاحظات الفترة',
    trial_action_complete: 'إنهاء الفترة',
    trial_action_cancel: 'إلغاء الفترة',
    trial_complete_title: 'إنهاء الفترة التجريبية',
    trial_cancel_title: 'إلغاء الفترة التجريبية',
    trial_complete_hint: 'وقت النهاية الفعلي افتراضياً الآن. يمكنك تعديله وإضافة ملاحظة.',
    trial_cancel_hint: 'تُعلَّم الفترة ملغاة وتُسجَّل نهايتها الآن. يُسجَّل ذلك في سجل العميل المحتمل.',
    toast_trial_started: 'بدأت الفترة التجريبية',
    toast_trial_updated: 'تم تحديث الفترة التجريبية',
    toast_trial_completed: 'تم إنهاء الفترة التجريبية',
    toast_trial_cancelled: 'تم إلغاء الفترة التجريبية',

    // ---- the offer to move the lead along the pipeline (never automatic)
    suggest_title: 'هل تنقل العميل المحتمل إلى مرحلة "{stage}"؟',
    suggest_hint: 'تسجيل النشاط لا يغيّر المرحلة تلقائياً. النقل خطوة منفصلة يتحقق منها الخادم.',
    suggest_move: 'نقل إلى "{stage}"',
    suggest_dismiss: 'ليس الآن',

    // ---- the activities panel on the lead page
    work_title: 'الأنشطة',
    work_hint: 'المكالمات والمتابعات والعروض والفترات التجريبية لهذا العميل المحتمل.',
    work_empty_calls: 'لا توجد مكالمات مسجلة بعد',
    work_empty_followups: 'لا توجد متابعات بعد',
    work_empty_demos: 'لا توجد عروض تجريبية بعد',
    work_empty_trials: 'لا توجد فترات تجريبية بعد',

    // ---- the overview on the workspace home
    home_work_title: 'عملك',
    tile_followups_overdue: 'متابعاتي المتأخرة',
    tile_followups_pending: 'متابعاتي المعلّقة',
    tile_demos_upcoming: 'عروضي المجدولة',
    tile_demos_past_due: 'عروض بحاجة إلى تسجيل النتيجة',
    tile_trials_active: 'فترات تجريبية نشطة',
    tile_trials_ending: 'فترات تنتهي قريباً',
    tile_calls_week: 'مكالمات آخر ٧ أيام',

    // ---- timeline
    event_call_created: 'تم تسجيل مكالمة',
    event_call_updated: 'تم تصحيح مكالمة',
    event_followup_created: 'تمت إضافة متابعة',
    event_followup_updated: 'تم تعديل متابعة',
    event_followup_completed: 'تم إنجاز متابعة',
    event_followup_cancelled: 'تم إلغاء متابعة',
    event_demo_scheduled: 'تمت جدولة عرض تجريبي',
    event_demo_rescheduled: 'تمت إعادة جدولة عرض تجريبي',
    event_demo_updated: 'تم تعديل عرض تجريبي',
    event_demo_completed: 'تم إتمام عرض تجريبي',
    event_demo_cancelled: 'تم إلغاء عرض تجريبي',
    event_demo_no_show: 'لم يحضر العرض التجريبي',
    event_trial_started: 'بدأت فترة تجريبية',
    event_trial_updated: 'تم تعديل فترة تجريبية',
    event_trial_completed: 'انتهت فترة تجريبية',
    event_trial_cancelled: 'تم إلغاء فترة تجريبية',
    timeline_due: 'الموعد',
    timeline_when: 'الوقت',
    timeline_started: 'البداية',
    timeline_expected_end: 'النهاية المتوقعة',
    timeline_ended: 'النهاية الفعلية',
    timeline_was_overdue: 'كانت متأخرة',
    timeline_duration: 'المدة',
    work_field_due_at: 'الموعد',
    work_field_notes: 'ملاحظات',
    work_field_assigned_to: 'المسؤول',
    work_field_result: 'النتيجة',
    work_field_duration_seconds: 'المدة',
    work_field_called_at: 'وقت المكالمة',
    work_field_scheduled_at: 'موعد العرض',
    work_field_expected_end_at: 'النهاية المتوقعة',

    // ---- server error codes
    err_lead_not_found: 'العميل المحتمل غير موجود',
    err_activity_assignee_required: 'اختر المسؤول عن هذا العنصر',
    err_activity_assignee_not_eligible: 'لا يمكن إسناد هذا العنصر إلى هذا الشخص. اختر موظفاً نشطاً يملك الصلاحية المناسبة.',
    err_activity_assignee_cannot_see_lead: 'هذا الشخص لا يستطيع الوصول إلى هذا العميل المحتمل، فلا يمكن إسناد العنصر إليه.',
    err_called_at_in_future: 'لا يمكن أن يكون وقت المكالمة في المستقبل',
    err_followup_not_pending: 'هذه المتابعة لم تعد قيد الانتظار',
    err_demo_not_scheduled: 'هذا العرض لم يعد مجدولاً',
    err_demo_same_time: 'العرض مجدول بالفعل في هذا الوقت',
    err_active_trial_exists: 'لهذا العميل المحتمل فترة تجريبية نشطة بالفعل. أنهِها أو ألغِها أولاً.',
    err_trial_not_active: 'هذه الفترة التجريبية لم تعد نشطة',
    err_expected_end_before_start: 'يجب أن تكون النهاية المتوقعة بعد البداية',
    err_started_at_in_future: 'لا يمكن أن تبدأ الفترة في المستقبل',
    err_actual_end_before_start: 'لا يمكن أن تسبق النهاية الفعلية البداية',
    err_actual_end_at_in_future: 'لا يمكن أن تكون النهاية الفعلية في المستقبل',
  },
  en: {
    // ---- navigation and page titles
    nav_followups: 'Follow-ups',
    nav_calls: 'Calls',
    nav_demos: 'Demos',
    nav_trials: 'Trials',
    followups_title: 'Follow-ups',
    calls_title: 'Calls',
    demos_title: 'Demos',
    trials_title: 'Trials',
    trials_subtitle: 'Sales-side tracking only - it does not create a subscription or change anything in customer accounts.',

    // ---- shared table / card labels
    act_col_lead: 'Lead',
    act_col_assignee: 'Assigned to',
    act_col_status: 'Status',
    act_col_actions: 'Actions',
    act_col_due: 'Due',
    act_col_when: 'When',
    act_col_employee: 'Made by',
    act_col_result: 'Result',
    act_col_duration: 'Duration',
    act_col_called_at: 'Called at',
    act_col_started: 'Started',
    act_col_expected_end: 'Expected end',
    act_col_ended: 'Ended',
    act_search_placeholder: 'Lead name or contact',
    act_no_notes: 'No notes',
    act_overdue: 'Overdue',
    act_past_due: 'Past due',
    act_ending_soon: 'Ending soon',
    act_trial_overdue: 'Past its expected end',
    act_needs_outcome: '{n} demo(s) need an outcome',
    act_lead_archived: 'Archived',
    act_error: "Couldn't load the list",
    act_empty_filtered_hint: 'Try clearing the filters.',
    act_you: 'you',
    act_note: 'Note',
    act_assignee: 'Assigned to',
    act_assignee_hint: 'Only staff who can work on this lead can be chosen.',
    act_assignee_none: 'Nobody can be given this yet. Assign the lead to a Sales Employee first.',
    act_required: 'This field is required',
    act_scope_hint: 'Only items on the leads you have access to are shown here.',

    // ---- calls
    call_result_answered: 'Answered',
    call_result_no_answer: 'No answer',
    call_result_busy: 'Busy',
    call_result_wrong_number: 'Wrong number',
    call_result_interested: 'Interested',
    call_result_not_interested: 'Not interested',
    call_result_call_back: 'Call back',
    calls_add: 'Log a call',
    calls_showing_recent: 'Most recent calls first',
    calls_empty: 'No calls logged yet',
    calls_empty_hint: "Log a call from a lead's page.",
    calls_empty_filtered: 'No calls match',
    calls_filter_from: 'From date',
    calls_filter_to: 'To date',
    calls_filter_made_by: 'Made by',
    calls_filter_mine: 'My calls',
    call_dialog_create_title: 'Log a call',
    call_dialog_edit_title: 'Edit call',
    call_dialog_hint: 'A call is a record of something that happened. Logging one never moves the lead in the pipeline by itself.',
    call_field_result: 'Result',
    call_field_result_placeholder: 'Choose the result',
    call_field_called_at: 'Time of the call',
    call_field_duration: 'Call duration',
    call_field_minutes: 'minutes',
    call_field_seconds: 'seconds',
    call_field_notes: 'Call notes',
    toast_call_created: 'Call logged',
    toast_call_updated: 'Call updated',

    // ---- follow-ups
    followup_status_pending: 'Pending',
    followup_status_completed: 'Completed',
    followup_status_cancelled: 'Cancelled',
    followups_tab_mine: 'My follow-ups',
    followups_tab_upcoming: 'Upcoming',
    followups_tab_overdue: 'Overdue',
    followups_tab_completed: 'Completed',
    followups_add: 'Add a follow-up',
    followups_empty_mine: 'No pending follow-ups are assigned to you',
    followups_empty_upcoming: 'No upcoming follow-ups',
    followups_empty_overdue: 'No overdue follow-ups',
    followups_empty_completed: 'No completed follow-ups yet',
    followups_empty_hint: "Add a follow-up from a lead's page.",
    followup_dialog_create_title: 'Add a follow-up',
    followup_dialog_edit_title: 'Edit follow-up',
    followup_field_due: 'Due',
    followup_field_notes: 'What needs to be done?',
    followup_action_complete: 'Complete',
    followup_action_cancel: 'Cancel follow-up',
    followup_complete_title: 'Complete follow-up',
    followup_complete_hint: "You can add a note about what was done. It's recorded on the lead's timeline.",
    followup_cancel_title: 'Cancel follow-up',
    followup_cancel_hint: "The follow-up is not deleted: it's marked cancelled and recorded on the lead's timeline.",
    toast_followup_created: 'Follow-up added',
    toast_followup_updated: 'Follow-up updated',
    toast_followup_completed: 'Follow-up completed',
    toast_followup_cancelled: 'Follow-up cancelled',

    // ---- demos
    demo_status_scheduled: 'Scheduled',
    demo_status_completed: 'Completed',
    demo_status_cancelled: 'Cancelled',
    demo_status_no_show: 'No-show',
    demos_tab_upcoming: 'Upcoming',
    demos_tab_completed: 'Completed',
    demos_tab_closed: 'Cancelled / No-show',
    demos_add: 'Schedule a demo',
    demos_empty_upcoming: 'No demos scheduled',
    demos_empty_completed: 'No completed demos yet',
    demos_empty_closed: 'No cancelled or no-show demos',
    demos_empty_hint: "Schedule a demo from a lead's page.",
    demo_dialog_create_title: 'Schedule a demo',
    demo_dialog_edit_title: 'Edit demo',
    demo_dialog_hint: 'Internal tracking only - there is no calendar integration. Scheduling a demo never moves the lead in the pipeline by itself.',
    demo_field_when: 'Demo time',
    demo_field_notes: 'Demo notes',
    demo_action_reschedule: 'Reschedule',
    demo_action_complete: 'Mark done',
    demo_action_cancel: 'Cancel',
    demo_action_no_show: 'No-show',
    demo_reschedule_title: 'Reschedule demo',
    demo_reschedule_hint: "The new time and the reason (optional) are recorded on the lead's timeline.",
    demo_complete_title: 'Record the demo as done',
    demo_cancel_title: 'Cancel demo',
    demo_no_show_title: 'Record a no-show',
    demo_end_hint: "You can add a note. It's recorded on the lead's timeline, and the status cannot be undone.",
    toast_demo_scheduled: 'Demo scheduled',
    toast_demo_updated: 'Demo updated',
    toast_demo_rescheduled: 'Demo rescheduled',
    toast_demo_completed: 'Demo recorded as done',
    toast_demo_cancelled: 'Demo cancelled',
    toast_demo_no_show: 'No-show recorded',

    // ---- trials (Sales-side tracking)
    trial_status_active: 'Active',
    trial_status_completed: 'Completed',
    trial_status_cancelled: 'Cancelled',
    trials_tab_active: 'Active',
    trials_tab_ending: 'Ending soon',
    trials_tab_completed: 'Completed',
    trials_tab_cancelled: 'Cancelled',
    trials_add: 'Start a trial',
    trials_empty_active: 'No active trials',
    trials_empty_ending: 'No trials ending soon',
    trials_empty_completed: 'No completed trials yet',
    trials_empty_cancelled: 'No cancelled trials',
    trials_empty_hint: "Start a trial from a lead's page.",
    trial_dialog_start_title: 'Start a trial',
    trial_dialog_edit_title: 'Edit trial',
    trial_dialog_hint: 'Sales-side tracking only: it does not create a subscription or change anything in customer accounts. A lead can have only one active trial.',
    trial_field_started: 'Trial start',
    trial_field_expected_end: 'Expected end',
    trial_field_actual_end: 'Actual end',
    trial_field_notes: 'Trial notes',
    trial_action_complete: 'End trial',
    trial_action_cancel: 'Cancel trial',
    trial_complete_title: 'End the trial',
    trial_cancel_title: 'Cancel the trial',
    trial_complete_hint: 'The actual end time defaults to now. You can change it and add a note.',
    trial_cancel_hint: "The trial is marked cancelled and its end is recorded as now. It's recorded on the lead's timeline.",
    toast_trial_started: 'Trial started',
    toast_trial_updated: 'Trial updated',
    toast_trial_completed: 'Trial ended',
    toast_trial_cancelled: 'Trial cancelled',

    // ---- the offer to move the lead along the pipeline (never automatic)
    suggest_title: 'Move this lead to "{stage}"?',
    suggest_hint: "Logging work doesn't change the stage by itself. Moving it is a separate step that the server checks.",
    suggest_move: 'Move to "{stage}"',
    suggest_dismiss: 'Not now',

    // ---- the activities panel on the lead page
    work_title: 'Activities',
    work_hint: 'Calls, follow-ups, demos and trials for this lead.',
    work_empty_calls: 'No calls logged yet',
    work_empty_followups: 'No follow-ups yet',
    work_empty_demos: 'No demos yet',
    work_empty_trials: 'No trials yet',

    // ---- the overview on the workspace home
    home_work_title: 'Your work',
    tile_followups_overdue: 'My overdue follow-ups',
    tile_followups_pending: 'My pending follow-ups',
    tile_demos_upcoming: 'My scheduled demos',
    tile_demos_past_due: 'Demos needing an outcome',
    tile_trials_active: 'Active trials',
    tile_trials_ending: 'Trials ending soon',
    tile_calls_week: 'Calls in the last 7 days',

    // ---- timeline
    event_call_created: 'Call logged',
    event_call_updated: 'Call corrected',
    event_followup_created: 'Follow-up added',
    event_followup_updated: 'Follow-up edited',
    event_followup_completed: 'Follow-up completed',
    event_followup_cancelled: 'Follow-up cancelled',
    event_demo_scheduled: 'Demo scheduled',
    event_demo_rescheduled: 'Demo rescheduled',
    event_demo_updated: 'Demo edited',
    event_demo_completed: 'Demo completed',
    event_demo_cancelled: 'Demo cancelled',
    event_demo_no_show: 'Demo no-show',
    event_trial_started: 'Trial started',
    event_trial_updated: 'Trial edited',
    event_trial_completed: 'Trial ended',
    event_trial_cancelled: 'Trial cancelled',
    timeline_due: 'Due',
    timeline_when: 'When',
    timeline_started: 'Started',
    timeline_expected_end: 'Expected end',
    timeline_ended: 'Ended',
    timeline_was_overdue: 'it was overdue',
    timeline_duration: 'Duration',
    work_field_due_at: 'Due',
    work_field_notes: 'Notes',
    work_field_assigned_to: 'Assigned to',
    work_field_result: 'Result',
    work_field_duration_seconds: 'Duration',
    work_field_called_at: 'Time of the call',
    work_field_scheduled_at: 'Demo time',
    work_field_expected_end_at: 'Expected end',

    // ---- server error codes
    err_lead_not_found: 'The lead was not found',
    err_activity_assignee_required: 'Choose who this is for',
    err_activity_assignee_not_eligible: "This can't be given to that person. Choose an active staff member with the right permission.",
    err_activity_assignee_cannot_see_lead: "That person can't access this lead, so this can't be given to them.",
    err_called_at_in_future: 'The time of a call cannot be in the future',
    err_followup_not_pending: 'This follow-up is no longer pending',
    err_demo_not_scheduled: 'This demo is no longer scheduled',
    err_demo_same_time: 'The demo is already scheduled for this time',
    err_active_trial_exists: 'This lead already has an active trial. End or cancel it first.',
    err_trial_not_active: 'This trial is no longer active',
    err_expected_end_before_start: 'The expected end must be after the start',
    err_started_at_in_future: 'A trial cannot start in the future',
    err_actual_end_before_start: 'The actual end cannot be before the start',
    err_actual_end_at_in_future: 'The actual end cannot be in the future',
  },
};
